export default {"src":"/_next/static/media/expand_icon.69e760ca.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};